/* istanbul ignore file */
import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { CardMode } from '@components/card/card.component';
import { MdsTextFieldComponent } from '@medpacesoftwaredevelopment/designsystem';
import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';
import { FormGroupValueOf } from '@utility/utility';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';

export class FlightPreferencesFormGroup extends PersistentFormGroup<{
    airlinePreference1: PersistentFormControl<string>;
    frequentFlyerNumber1: PersistentFormControl<string>;
    airlinePreference2: PersistentFormControl<string>;
    frequentFlyerNumber2: PersistentFormControl<string>;
    seatPreference: PersistentFormControl<string>;
    specialNeeds: PersistentFormControl<string>;
    knownTravelerNumber: PersistentFormControl<string>;
}> {
    public static create(value: FormGroupValueOf<FlightPreferencesFormGroup>): FlightPreferencesFormGroup {
        return new FlightPreferencesFormGroup({
            airlinePreference1: new PersistentFormControl(value.airlinePreference1, [
                notWhitespaceValidator(),
                maxLengthValidator(50),
            ]),
            frequentFlyerNumber1: new PersistentFormControl(value.frequentFlyerNumber1, [
                notWhitespaceValidator(),
                maxLengthValidator(50),
            ]),
            airlinePreference2: new PersistentFormControl(value.airlinePreference2, [
                notWhitespaceValidator(),
                maxLengthValidator(50),
            ]),
            frequentFlyerNumber2: new PersistentFormControl(value.frequentFlyerNumber2, [
                notWhitespaceValidator(),
                maxLengthValidator(50),
            ]),
            seatPreference: new PersistentFormControl(value.seatPreference, [
                notWhitespaceValidator(),
                maxLengthValidator(75),
            ]),
            specialNeeds: new PersistentFormControl(value.specialNeeds, [
                notWhitespaceValidator(),
                maxLengthValidator(500),
            ]),
            knownTravelerNumber: new PersistentFormControl(value.knownTravelerNumber, [
                notWhitespaceValidator(),
                maxLengthValidator(20),
            ]),
        });
    }
}
@Component({
    selector: 'medpace-flight-preferences',
    templateUrl: './flight-preferences.component.html',
    styleUrls: ['./flight-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MdsTextFieldComponent],
})
export class FlightPreferencesComponent {
    public readonly formGroup: InputSignal<FlightPreferencesFormGroup> = input.required<FlightPreferencesFormGroup>();
    public readonly mode: InputSignal<CardMode> = input.required<CardMode>();
}
